import {createAction} from '../../base/fsa';
import {SettingsModel} from './state';

export const setSettingsAction = createAction(
    resolve => (settings: SettingsModel) => resolve(settings),
);

export const setConnectedWifiAction = createAction(
    resolve => (connectedWifi: string) => resolve(connectedWifi),
);
